// Per-county "Why choose a local Xero accountant" copy — deepens local relevance
// on every town page without duplicating content (grouped by county).
export const COUNTY_COPY = {
  Staffordshire: {
    heading: "Why choose a local Xero accountant in Staffordshire",
    body:
      "Staffordshire's economy blends manufacturing and logistics along the A5 and M6 corridors with a thriving base of professional services and independent businesses. A local Xero accountant who understands that mix — and who's a short drive away when you need them — gives you real-time numbers and advice that actually fits how you trade.",
    points: [
      "On-the-ground understanding of Staffordshire's manufacturing, logistics and service sectors",
      "A Tamworth-based team you can meet in person, not a faceless national firm",
      "Real-time Xero visibility so you're never working from out-of-date accounts",
    ],
  },
  "West Midlands": {
    heading: "Why choose a local Xero accountant in the West Midlands",
    body:
      "The West Midlands is one of the UK's most dynamic business regions — from Birmingham's professional services and tech scene to the Black Country's manufacturing heartland. A local Xero accountant helps you cut through that pace with clear, real-time numbers and a dedicated contact who knows your business by name.",
    points: [
      "Familiar with the region's professional services, tech and manufacturing base",
      "Boutique, hands-on support backed by senior financial expertise",
      "Cloud accounting that keeps you connected wherever you're based in the region",
    ],
  },
  Warwickshire: {
    heading: "Why choose a local Xero accountant in Warwickshire",
    body:
      "Warwickshire pairs engineering, distribution and automotive innovation with a strong community of owner-managed and family businesses. A local Xero accountant gives you the forecasting and insight to make confident decisions, with the personal service that a close-knit business county values.",
    points: [
      "Experience with Warwickshire's engineering, automotive and owner-managed businesses",
      "Quarterly strategic reviews so you plan ahead, not just look back",
      "A dedicated day-to-day contact with a direct dial and clear working hours",
    ],
  },
  Derbyshire: {
    heading: "Why choose a local Xero accountant in Derbyshire",
    body:
      "South Derbyshire's mix of manufacturing, retail and trades — set around the National Forest — rewards a straightforward, reliable finance partner. A local Xero accountant keeps your bookkeeping accurate and your cash flow clear, with proactive support all year round rather than a once-a-year catch-up.",
    points: [
      "Understanding of Derbyshire's manufacturing, retail and trades businesses",
      "Real-time cash flow visibility through Xero cloud accounting",
      "Fixed monthly fees with unlimited support — no surprise bills",
    ],
  },
  Leicestershire: {
    heading: "Why choose a local Xero accountant in Leicestershire",
    body:
      "Leicestershire sits at the heart of England's logistics 'Golden Triangle', alongside manufacturing, distribution and a growing services sector. A local Xero accountant helps you stay on top of fast-moving numbers, understand your true margins and plan investment with confidence.",
    points: [
      "Comfortable with Leicestershire's logistics, distribution and manufacturing sectors",
      "Clear reporting on profitability and cash flow when it matters",
      "Seamless Xero support by video and cloud, with in-person meetings when they help",
    ],
  },
};

export const getCountyCopy = (county) => COUNTY_COPY[county] || null;
